import { createContext } from "react";

export interface SidebarNavContextValue {
  isOverlayOpen: boolean;
  openOverlay: () => void;
  closeOverlay: () => void;
  toggleOverlay: () => void;
}

export const SidebarNavContext = createContext<SidebarNavContextValue | null>(
  null
);
